export type CreatePaymentRequest = {
  amount: number;
};

export type CreatePaymentResponse = {
  redirectUrl: string;
};

export type GetWalletBalanceRequest = {
  domain_slug: string;
};

export type GetWalletBalanceResponse = {
  balance: number;
  personalBalance: number;
  aiBalance: number;
};

export type GetWalletBalanceApiData = {
  balance?: number | string;
  personal_balance?: number | string;
  ai_balance?: number | string;
};

/** 1 = کیف پول شخصی، 2 = کیف پول AI */
export type WalletType = 1 | 2;

export const WALLET_TYPE_PERSONAL: WalletType = 1;
export const WALLET_TYPE_AI: WalletType = 2;

export type WalletTransactionItem = {
  id: string;
  amount: string;
  sign: 1 | -1;
  description: string;
  type: number;
  is_gift: boolean;
  created_at: string;
};

export type GetWalletTransactionsRequest = {
  page?: number;
  perPage?: number;
  wallet_type: WalletType;
};

export type GetWalletTransactionsResponse = {
  rows: WalletTransactionItem[];
  total: number;
};

export type WalletOrderItem = {
  id: string;
  number: string;
  amount: string;
  status: number;
  created_at: string;
  paid_at: string | null;
  hesabfa_factor_number: string | null;
  tracking_code: string | null;
  ref_id: string | null;
};

export type GetWalletOrdersRequest = {
  page?: number;
  perPage?: number;
};

export type GetWalletOrdersResponse = {
  rows: WalletOrderItem[];
  total: number;
};
